import { render, staticRenderFns } from "./CompareLabel.vue?vue&type=template&id=ffa8d01e&"
import script from "./CompareLabel.vue?vue&type=script&lang=js&"
export * from "./CompareLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports